import React, { useState } from "react";
import Leftsidebar from "../layout/Leftsidebar";
import StoreListing from "./StoreListing";
import StoreStockDetails from "./StoreStockDetails";
import { useStoreStock } from "../context/StoreStockContext";

const StoreSectionPage = () => {
  const { showStoreStock, loading } = useStoreStock();
  const [sidebarShow, setSidebarShow] = useState(false);

  return (
    <div className="section-full-wrapper">
      <Leftsidebar setSidebarShow={setSidebarShow} sidebarShow={sidebarShow} />
      {showStoreStock == true || loading ? (
        <StoreStockDetails
          setSidebarShow={setSidebarShow}
          sidebarShow={sidebarShow}
        />
      ) : (
        <StoreListing
          setSidebarShow={setSidebarShow}
          sidebarShow={sidebarShow}
        />
      )}
    </div>
  );
};

export default StoreSectionPage;
